// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--eKnvv","aside":"_7a3fb80146--aside--WvTGp"};